import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { faqs } from "../../mock/mock";

const FAQSection = () => {
  return (
    <section className="py-20 pattern-warm">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="lg:sticky lg:top-24">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-orange-100 mb-4">
              <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">FAQs</span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4 leading-tight">
              Questions Parents<br />
              <span className="text-orange-600">Often Ask</span>
            </h2>
            <p className="text-stone-600 mb-6">Everything you need to know before enrolling your little one at Aadi Gayanam. Still have questions?</p>
            <a href="tel:+917617755821" className="inline-flex items-center gap-2 font-semibold text-orange-700 hover:text-orange-800">
              Call us at +91 7617755821 →
            </a>
          </div>

          <div>
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="bg-white rounded-2xl border border-orange-100 px-5 shadow-sm"
                >
                  <AccordionTrigger className="text-left font-display font-semibold text-stone-800 hover:no-underline py-5">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-stone-600 leading-relaxed pb-5">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
